import CRegexp from "@/src-refactor/modules/shared/model/const/regexp/regexp.const";
import { SchemaFileDataGenericValidation } from "@rf/schemas/file-data-generic.schema";
import { array, string } from "yup";

const multimediaSepSchema = {
  // media
  images_property: array()
    .label("Imágenes")
    .of(SchemaFileDataGenericValidation)
    .min(3, "Debe subir por los menos 3 imágenes")
    .max(20, "Solo es posible adjuntar 20 imágenes")
    .default([]),

  videos_property: array()
    .label("Videos")
    .of(
      string()
        .label("Video")
        .transform(value => {
          if (typeof value === "string") {
            return value.trim();
          }
          if (value === null || value === undefined) {
            return "";
          }
          return "";
        })
        .url("Debe ser una URL válida")
        .matches(CRegexp.YOUTUBE_URL, {
          message: "Debe ser una URL de youtube",
          excludeEmptyString: true
        })
        .default("")
    )
    .default(["", "", ""])
    .test({
      name: "is-unique",
      message: "Cada video debe ser único",
      test: value => {
        const filteredArray = value?.filter(
          item => item !== undefined && item !== "" && item !== null
        );
        if (!filteredArray || filteredArray.length <= 1) return true;
        const isUnique = filteredArray.every((item, index) => {
          return filteredArray.indexOf(item) === index;
        });
        return isUnique;
      }
    }),
  tour_virtual_property: string().label("Tour virtual").default(""),
  dropbox_link_property: string().label("Dropbox").default(""),
  drive_link_property: string().label("Drive url").default("")
};

export default multimediaSepSchema;
